<template>
    <settings-control label="Size">
        <dropdown
            theme="minimalistic"
            placeholder="Select Size"
            :options="options"
            :value="fontSize"
            native
            @input="onInput"
        />
    </settings-control>
</template>

<script>
import SettingsControl from '@/components/settings/shared/settings-control';
import mapFilters from '@/utils/map-filters';
import { getNumberFromCssValue } from '@/utils/string';
import { tailwindConfig } from '@/data/tailwind';

const configValues = tailwindConfig.theme.fontSize;

export default {
    name: 'settings-control-font-size',
    components: { SettingsControl },

    props: {
        value: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            fontSize: this.value,
        };
    },

    computed: {
        options() {
            const defaultOption = { text: 'Default', value: '' };
            const sizeOptions = Object.keys(configValues)
                .map(key => ({
                    text: this.px(configValues[key]),
                    value: configValues[key],
                }))
                .sort((a, b) => getNumberFromCssValue(a.value) - getNumberFromCssValue(b.value));

            return [defaultOption].concat(sizeOptions);
        },
    },

    watch: {
        value(newVal) {
            this.fontSize = newVal;
        },
    },

    methods: {
        ...mapFilters(['px']),

        onInput(value) {
            this.fontSize = value;

            this.$emit('input', {
                tailwindDefinitionProp: 'fontSize',
                value,
            });
        },
    },
};
</script>
